module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "m-0 d-inline-flex form-control w-100 border-0 rounded",
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": _vm.handleInputFocus,
      "click": _vm.handleInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center text-center"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "spinner"
  }) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c("caret", {
    tag: "component",
    attrs: {
      "options-count": _vm.optionsCount,
      "dropdown-list-count": _vm.dropdownListCount,
      "is-show-dropdown-list": _vm.isShowDropdownList,
      "on-show-dropdown-list": _vm.onShowDropdownList,
      "on-hide-dropdown-list": _vm.onHideDropdownList
    }
  }) : _vm._e()], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a1fbebe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search.vue
// module id = 98
// module chunks = 0